var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "invoice-container", class: _vm.wrapperClass },
    [
      _c("icon-view", {
        staticClass: "ml-2",
        attrs: { icon: "fa fa-flag", title: "Discusión de Plan" }
      }),
      _c("validation-observer", { ref: "invoicePlan" }, [
        _c(
          "div",
          { staticClass: "row mx-0 ml-md-4" },
          [
            _c(
              "div",
              { staticClass: "col-12 col-md-3 mt-3" },
              [
                _c("label", { attrs: { for: "invoice" } }, [
                  _vm._v(" ¿Estará facturando la discusión del plan? ")
                ]),
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-radio", {
                            key: _vm.model.date,
                            attrs: {
                              "custom-error-msg":
                                "Favor marcar si estará facturando la discusión del plan.",
                              disabled: !_vm.continueEditing,
                              error: Boolean(errors[0]),
                              "is-inline": "",
                              name: "invoice",
                              options: _vm.defaultOptions
                            },
                            on: { input: _vm.invoiceChange },
                            model: {
                              value: _vm.model.invoice,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "invoice", $$v)
                              },
                              expression: "model.invoice"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm.model.invoice && _vm.model.invoice.value
              ? [
                  _c(
                    "div",
                    { staticClass: "col-12 mt-3 col-md-3" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      id: "serviceSpecialist",
                                      disabled: !_vm.continueEditing,
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label:
                                        "Especialista que discutió el plan: ",
                                      name: "serviceSpecilist",
                                      options: _vm.specialists
                                    },
                                    model: {
                                      value:
                                        _vm.model.referralOverrideSpecialist,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "referralOverrideSpecialist",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "model.referralOverrideSpecialist"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1042477429
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 mt-3 col-md-2" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-date-picker", {
                                    attrs: {
                                      "class-container": "",
                                      "custom-error-msg":
                                        "La fecha es requerida.",
                                      disabled: !_vm.continueEditing,
                                      error: errors[0],
                                      label: "Fecha:",
                                      "max-date": _vm.maxDate,
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    model: {
                                      value: _vm.model.date,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "date", $$v)
                                      },
                                      expression: "model.date"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3130065522
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 mt-3 col-md-2" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-time-picker", {
                                    attrs: {
                                      "class-container": "",
                                      "custom-error-msg":
                                        "La hora desde es requerida.",
                                      disabled: !_vm.continueEditing,
                                      "end-time-value": "19:55",
                                      error: errors[0],
                                      label: "Hora Desde:",
                                      placeholder: "HH:mm"
                                    },
                                    model: {
                                      value: _vm.model.startTime,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "startTime", $$v)
                                      },
                                      expression: "model.startTime"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2898482310
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 mt-3 col-md-2" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-time-picker", {
                                    attrs: {
                                      "class-container": _vm.invalidHour
                                        ? "invalidated"
                                        : "",
                                      "custom-error-msg":
                                        "La hora hasta es requerida.",
                                      disabled: !_vm.continueEditing,
                                      "end-time-value": "20:00",
                                      error: errors[0],
                                      label: "Hora Hasta:",
                                      placeholder: "HH:mm"
                                    },
                                    model: {
                                      value: _vm.model.endTime,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "endTime", $$v)
                                      },
                                      expression: "model.endTime"
                                    }
                                  }),
                                  _vm.invalidHour
                                    ? _c("custom-error", {
                                        attrs: {
                                          message:
                                            "La hora hasta no puede ser menor a la desde.",
                                          variant: "no-border"
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3030997077
                        )
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            !_vm.readOnly
              ? _c(
                  "div",
                  { staticClass: "col-12 mt-3" },
                  [
                    _vm.continueEditing
                      ? [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-end w-100 mr-3"
                              },
                              [
                                _c("action-button", {
                                  attrs: {
                                    i: "fas fa-times-circle",
                                    text: "Cancelar",
                                    variant: "outline-danger mr-md-1"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancel()
                                    }
                                  }
                                }),
                                _c("action-button", {
                                  attrs: {
                                    i: "fas fa-save",
                                    text: "Guardar",
                                    variant: "success ml-md-1 mt-md-0 mt-2"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.save()
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      : _vm._e(),
                    !_vm.onlyShowPlan &&
                    !_vm.continueEditing &&
                    this.userHasPermissions("interventionplan.canedit") &&
                    ((_vm.isSignHubActive &&
                      !_vm.isInterventionPlanElectronicSigned &&
                      !_vm.interventionFlags.isAmending &&
                      !_vm.interventionFlags.isSubmitted &&
                      this.info.canChangeBill) ||
                      (_vm.interventionFlags.isSubmitted &&
                        this.info.canChangeBill) ||
                      (_vm.interventionFlags.isBillingSubmitted &&
                        _vm.interventionFlags.isAmending &&
                        this.info.canChangeBill) ||
                      !_vm.isSignHubActive)
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-end w-100 mr-3"
                            },
                            [
                              _c("action-button", {
                                attrs: {
                                  i: "fas fa-edit",
                                  text: "Editar",
                                  variant: "outline-success"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.editMode()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }